import { Command } from 'commander';
import { ApiClient } from '../client.js';
import { formatOutput } from '../output.js';
import { getBase, getFormat, parseData } from '../helpers.js';
import { confirm } from '../prompt.js';

export const toolsCommand = new Command('tools')
  .description('Manage Tools — reusable, named single-operation definitions (one record_type + one operation)');

toolsCommand.command('upsert <id>')
  .description('Create or update a Tool (one record_type + one operation)')
  .option('--record_type <record_type>', 'The record_type this tool operates over')
  .option('--operation <op>', 'The operation: create | get | list | update | delete')
  .option('--description <desc>', 'Agent-facing description')
  .option('--config <json>', 'Full Tool config as JSON (writable_fields, filterable_fields, precondition, binding, external_source, expose_*/default_*, agent_minimal). Use @file.json to read from file.')
  .action(async function (this: Command, id: string, opts: {
    record_type?: string;
    operation?: string;
    description?: string;
    config?: string;
  }) {
    const ws = getBase(this);
    const client = new ApiClient();

    let body: Record<string, unknown>;
    if (opts.config) {
      body = parseData(opts.config);
      if (opts.record_type) body.record_type = opts.record_type;
      if (opts.operation) body.operation = opts.operation;
      if (opts.description) body.description = opts.description;
    } else {
      if (!opts.record_type || !opts.operation) {
        console.error('Provide --record_type and --operation (or --config <json>).');
        process.exit(1);
      }
      body = { record_type: opts.record_type, operation: opts.operation };
      if (opts.description) body.description = opts.description;
    }

    const data = await client.request('PUT', `/v1/${ws}/tools/${id}`, body);
    console.log(formatOutput(data, getFormat(this)));
  });

toolsCommand.command('get <id>')
  .description('Get a Tool by id')
  .action(async function (this: Command, id: string) {
    const ws = getBase(this);
    const client = new ApiClient();
    const data = await client.request('GET', `/v1/${ws}/tools/${id}`);
    console.log(formatOutput(data, getFormat(this)));
  });

toolsCommand.command('list')
  .description('List Tools in this database')
  .action(async function (this: Command) {
    const ws = getBase(this);
    const client = new ApiClient();
    const data = await client.request('GET', `/v1/${ws}/tools`);
    console.log(formatOutput(data, getFormat(this)));
  });

toolsCommand.command('delete <id>')
  .description('Delete a Tool')
  .option('-y, --yes', 'Skip confirmation')
  .action(async function (this: Command, id: string, opts: { yes?: boolean }) {
    if (!opts.yes && !(await confirm(`Delete tool ${id}? This cannot be undone.`))) {
      console.log('Aborted.');
      return;
    }
    const ws = getBase(this);
    const client = new ApiClient();
    await client.request('DELETE', `/v1/${ws}/tools/${id}`);
    console.log(`Deleted tool ${id}`);
  });
